import Icon from '../../bases/icone/icon';

import ArrowDown from './../assets/arrow-down.png';
import ArrowUp from './../assets/arrow-up.png';

function SortIcon({ order }) {
  if (!order) {
    return <></>;
  }

  if (order === 'asc') {
    return (
      <Icon image={ArrowUp} button={false} alt={'Asc'} width={16} height={16} />
    );
  } else {
    return (
      <Icon
        image={ArrowDown}
        button={false}
        alt={'Desc'}
        width={16}
        height={16}
      />
    );
  }
}

export default SortIcon;
